import React from 'react';
import styled from 'styled-components';
import { Container, Section, PageHero, HeroArt, Reveal, Card } from '../components/ui';

/* broadcast motif — a mic emitting concentric copper waves */
const SpeakersArt = (
  <HeroArt viewBox="0 0 340 260" aria-hidden="true">
    {/* radiating waves from the mic */}
    <path className="frame soft pulse" d="M150 130 A 70 70 0 0 1 150 -10" transform="rotate(-30 150 130)" />
    <path className="frame soft pulse d1" d="M150 130 A 108 108 0 0 1 150 -86" transform="rotate(-30 150 130)" />
    <path className="frame soft pulse d2" d="M150 130 A 150 150 0 0 1 150 -170" transform="rotate(-30 150 130)" />
    {/* mic capsule */}
    <rect className="frame" x="120" y="60" width="44" height="92" rx="22" />
    <path className="frame soft" d="M104 120 a38 38 0 0 0 76 0" />
    <line className="frame" x1="142" y1="158" x2="142" y2="196" />
    <line className="frame" x1="120" y1="196" x2="164" y2="196" />
    <circle className="node" cx="142" cy="82" r="3.4" />
    <circle className="node" cx="142" cy="108" r="3.4" />
  </HeroArt>
);

const ComingSoonCard = styled(Card)`
  padding: clamp(2rem, 6vw, 4rem);
  text-align: center;

  h2 {
    color: var(--copper-bright);
    font-size: clamp(2rem, 5vw, 3rem);
    margin-bottom: 1rem;
  }

  p {
    color: var(--ink-dim);
    line-height: 1.7;
  }
`;

export default function Speakers() {
  return (
    <>
      <PageHero
        kicker="Distinguished Speakers"
        index="06"
        title="Speakers"
        lead="The IEMENTech 2026 speaker lineup will be announced soon."
        art={SpeakersArt}
      />

      <Section>
        <Container>
          <Reveal>
            <ComingSoonCard>
              <h2>Coming Soon</h2>
              <p>Stay tuned for updates on our speakers.</p>
            </ComingSoonCard>
          </Reveal>
        </Container>
      </Section>
    </>
  );
}
